import { GridColDef } from "@mui/x-data-grid-pro";
import { TablePage } from "components/alove/TablePage";
import { useEffect, useState } from "react";
import { getAllEnded } from "utils/introductionUtils";
import { getGeneralCodes } from "utils/generalCodesUtils";
import { GeneralCode, GeneralCodeType } from "models/content/GeneralCode";
import { Introduction, IntroductionStatusReason } from "models/introduction/Introduction";
import { AppFeature, hasFeature } from "utils/settingsUtils";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { getNamesAsync } from "utils/enduserUtils";
import { UserName } from "components/alove/UserName";
import { Avatar, capitalize } from "@mui/material";
import { avatarUrl, formatDate } from "utils/globalsUtils";
import { Grid } from "@mui/material";
import { T } from "components/alove/Translator";
const DashboardNavbar = require("examples/Navbars/DashboardNavbar/index.js").default;

const MDTypography = require("components/MDTypography").default;



const DeclinesList = () => {
  const [unmatchReasons, setUnmatchReasons] = useState([] as GeneralCode[]);

  useEffect(() => {
    // Get unmatch reasons
    getGeneralCodes(GeneralCodeType.UnmatchReason).then((res) => {
      setUnmatchReasons(res);
    });
  }, []);
  const MMChip = ({row}) =>
      row.boUser?.firstName ? (
        <Grid
          style={{
            alignItems: "center",
            display: "flex",
            backgroundColor: "#f5f5f5",
            borderRadius: "15px",
            justifyContent: "left",
            marginTop: "5px",
          }}
          sx={{ p: 1, mr: 2 }}
          gap={1}
        >
          <Avatar src={row.boUser ?.avatar} sx={{ width: 24, height: 24 }} />
          <MDTypography
            variant="body2"
            style={{
              fontSize: "12px",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {row.boUser?.firstName}
          </MDTypography>
        </Grid>
      ) : (
        <T>noMMAssigned</T>
      )
    

  const columns: GridColDef[] = [
    // {
    //   field: "introductionId",
    //   headerName: "Id",
    //   flex: 1
    // },
    {
      field: "mmChip",
      headerName: "MM",
      renderCell: (params) => <MMChip row={params.row} />,
      width: 100
    },
    {
      field: "updated",
      headerName: "Updated",
      valueFormatter: (v, row: Introduction) => formatDate(row.updated),
      flex: 1,
    },
    {
      headerName: "",
      field: "initiatorUserAvatar",
      width: 50,
      renderCell: (params) => (
        <Grid container alignItems="center" height="100%">
          <Avatar src={avatarUrl(params.row.initiatorProfileId, params.row.initiatorImage?.uri)} />
        </Grid>
      ),
    },
    {
      field: "initiator",
      headerName: "Inititor",
      renderCell  : (params) =>  <UserName userId={params.row.initiatorProfile.userId} />,
      flex: 1
    },

    {
      field: "initiatorUserType",
      headerName: "Type",
      valueGetter: (v, row: Introduction) => capitalize(row.initiatorProfile.attributesValues["userType"]?.[0] || ""),
      flex: 1
    },
    {
      field: "initiatorScore",
      headerName: "Score",
      valueGetter: (v, row: Introduction) => Math.round(row.initiatorMatchScore),
      width: 50
    },
    {
      field: "initiatorReason",
      headerName: "Reason",
      valueGetter: (v, row: Introduction) =>
        row.statusReasonObj?.unmatchReasonInitiator,
      flex: 1,
    },
    {
      headerName: "",
      field: "responderUserAvatar",
      width: 50,
      renderCell: (params) => (
        <Grid container alignItems="center" height="100%">
          <Avatar src={avatarUrl(params.row.responderProfileId, params.row.responderImage?.uri)} />
        </Grid>
      ),
    },
    {
      field: "responder",
      headerName: "Responder",
      renderCell  : (params) =>  <UserName userId={params.row.responderProfile.userId} />,
      flex: 1
    },{
      field: "responderUserType",
      headerName: "Type",
      valueGetter: (v, row: Introduction) => capitalize(row.responderProfile.attributesValues["userType"]?.[0] || ""),
      flex: 1
    },
    {
      field: "responderScore",
      headerName: "Score",
      valueGetter: (v, row: Introduction) => Math.round(row.responderMatchScore),
      width: 50
    },
    {
      field: "responderReason",
      headerName: "Reason",
      valueGetter: (v, row: Introduction) =>
        row.statusReasonObj?.unmatchReasonResponder,
      flex: 1
    },
    {
      field: "reason",
      headerName: "Reason",
      valueGetter: (v, row: Introduction) => 
        row.statusReasonObj?.unmatchReason?.toString().split(",").map((r) =>
        unmatchReasons.find((rs) => rs.id.toString() == r)?.name).join(","),
      flex: 1
    },
    {
      field: "otherReason",
      headerName: "Other Reason",
      valueGetter: (v, row: Introduction) => row.statusReasonObj?.unmatchReasonOther,
      flex: 1,
    },
    {
      field: "date",
      headerName: "# Date",
      valueGetter: (v, row: Introduction) => row.statusReasonObj?.dateNumber,
      flex: 1,
    },
  ];

  const loadDeclines = async (filters, page) => {
    const allRequests = await getAllEnded(filters,page);

    getNamesAsync(
      allRequests
        .map((r) => [r.initiatorProfile.userId, r.responderProfile.userId]).flat())
    
    return allRequests
      ?.map((r) => Object.assign(new Introduction(), r))
  } 
  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="Shidduch Declines" />
        <TablePage
          table={{
            loadNext: loadDeclines,
            columns,
            lineClick: (p) => window.open(`#/introductions/${p.row.introductionId}`),
            getRowId: (row) => row.introductionId,
          
          }}
          filters={[
            // {
            //   key: "userType",
            //   label: "User Type",
            //   type: "select",
            //   options: [
            //     { key: "parent", label: "Parent" },
            //     { key: "child", label: "Child" }
            //   ]
            // },
            // {
            //   key: "gender",
            //   label: "Gender",
            //   type: "select",
            //   options: [
            //     { key: "man", label: "Man" },
            //     { key: "woman", label: "Woman" }
            //   ]
            // },
            {
              key: "met",
              label: "Met",
              type: "select",
              options: [
                { key: "met", label: "Met" },
                { key: "notMet", label: "Not met" }
              ]
            }
          ]}
          title="Shidduch Declines"
          rerenderKey={unmatchReasons.length.toString()}
        />
    </DashboardLayout>
  );
};

export default DeclinesList; 